import React, { useEffect, useState } from "react";
import { Link } from "react-router-dom";
import Steps from "../components/Steps";
import Testimonial from "../components/Essentials/Testimonial";
import PerService from "../components/Essentials/PerService";
import Spinner from "../components/Spinner";
import heroImage from "../assets/city.jpg";
import AboutSection from "../components/AboutSection";
import Frequentqes from "../components/Essentials/Frequentqes";
import Review from "../components/Review";


const Home = () => {
  const [isLoaded, setIsLoaded] = useState(false);

  const imagesToLoad = [heroImage];

  useEffect(() => {
    document.title = "Senior Vault Capital"; // Change the title
    // Preload all images
    const preloadImages = imagesToLoad.map((src) => {
      return new Promise((resolve, reject) => {
        const img = new Image();
        img.src = src;
        img.onload = resolve;
        img.onerror = reject;
      });
    });

    Promise.all(preloadImages)
      .then(() => {
        setIsLoaded(true); // All images are loaded
      })
      .catch((error) => {
        console.error("Error loading images:", error);
        setIsLoaded(true); // Fallback: Consider loading complete even if some images fail
      });
  }, []);

  return (
    <div className="bg-[#fff] overflow-x-hidden">
      {!isLoaded && <Spinner />}
      {isLoaded && (
        <>
          {/* Hero Section */}
          <div 
            className="relative w-full h-[67vh] sm:h-[67vh] md:h-[73vh] lg:h-[75vh] overflow-hidden my-12 hero-height"
            style={{ backgroundImage: `url(${heroImage})`, backgroundSize: "cover", backgroundPosition: "center" }}
          >
            <div className="absolute inset-0 flex flex-col items-center justify-center text-center pt-16 sm:pt-8 md:pt-12 lg:pt-16 px-4 sm:px-6 md:px-8 bg-black bg-opacity-50">
              <h1 className="text-3xl sm:text-3xl md:text-5xl lg:text-6xl font-bold text-white mb-3 sm:mb-2 md:mb-3 leading-snug sm:leading-tight md:leading-tight max-w-3xl tracking-wide">
              Senior<span><br/>Vault Capital</span>
              </h1>
              <p className="text-xl sm:text-lg md:text-xl lg:text-2xl text-white max-w-xs sm:max-w-xl md:max-w-2xl mb-4 sm:mb-3 md:mb-6 lg:mb-12 px-2 sm:px-6 leading-relaxed">
                Unlock the capital you need to grow, innovate, and achieve your boldest ambitions
              </p>       
              
              <div className="flex flex-wrap space-x-0 sm:space-x-4 justify-center gap-2 sm:gap-0 pb-4 pt-1 sm:pt-4 md:pt-0 lg:pt-0">
                <Link
                  to="/contact"
                   onClick={() => window.scrollTo(0, 0)}
                  className="bg-[#fff] border-2 border-gray-50 text-[#000] text-md lg:text-lg font-semibold py-2 px-6 sm:px-6 md:px-8 lg:px-8 sm:py-4
                  md:py-4 lg:py-3 rounded-xl sm:rounded-xl md:rounded-md lg:rounded-md hover:bg-white hover:text-black transition-all duration-300 transform hover:scale-105 shadow-xl"
                >
                  Get Started
                </Link>
                
              </div>
            </div>
          </div>
          
          {/* Other Sections */}
          <Review/>
       
          <AboutSection />
          {/* <Support /> */}
          <Steps />
          <Testimonial />
          {/* <DailyStats /> */}
          <PerService />
          {/* <Partners /> */}
          <Frequentqes />

        </>
      )}
    </div>
  );
};

export default Home;
